<div class="trucking-component">
  <div class="heading flex flex-row justify-between">
    <h2>Subcarrier Contracts</h2>
    <div class="self-center">
      <button class="h-auto" mat-flat-button color="primary" (click)="createEdit$$.next({})">ADD NEW</button>
    </div>
  </div>

  <div>
    <div class="grid grid-cols-9 gap-1 table-header items-center">
      <div>Broker</div>
      <div>Subcarrier</div>
      <div>Main Contract</div>

      <div *ngFor="let trailerType of brokerTrailerTypes$ | async">
        {{ trailerType.trailerTypeName }}
      </div>
    </div>
    <div class="table-body">
      <div
        *ngFor="let contract of subcarrierContracts$ | async; trackBy: subcarrierContracts$ | trackByKey: 'id'"
        class="grid grid-cols-9 gap-1 items-center row cursor-pointer"
        (click)="editContract(contract)"
      >
        <div class="cell">{{ contract.brokerName }}</div>
        <div class="cell">{{ contract.subcarrierName }}</div>
        <div class="cell">{{ contract.mainContractName | dashIfNothing }}</div>
        <div class="cell" *ngFor="let trailerType of brokerTrailerTypes$ | async">
          {{ contract.trailerTypeContracts[trailerType.id]?.contractName | dashIfNothing }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="createEdit$$ | async as openCreate">
  <div class="back-layer-component" (click)="closeNewContractForm()"></div>
  <sa-subcarrier-vendor-contract-create-edit [editContracts]="openCreate" (onCloseClicked)="closeNewContractForm()">
  </sa-subcarrier-vendor-contract-create-edit>
</ng-container>
